export default __webpack_public_path__ + "static/media/glassdoor_logo.bc0a3ae5.svg";